<template>
  <div
    class="textfield"
    :class="{
      'textfield--error': !valid
    }">
    <input
      v-model="text"
      :type="type"
      :required="required"
      :placeholder="placeholder"
      :name="name" >
  </div>
</template>

<script>
export default {
  name: 'TextField',
  props: {
    valid: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'field'
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: 'field'
    }
  },
  data() {
    return {
      text: null
    }
  }
}
</script>

<style lang="scss" scoped>
.textfield {
  appearance: none;
  padding: 0;
  border: 0;
  outline: none;
  width: 100%;
  margin: 0 0 $padding 0;
  input {
    padding: 20px 24px 16px 24px;
    font-size: $body;
    font-family: $suisse;
    width: 100%;
    border: 2px solid $black;

    &::placeholder {
      color: $dk-grey;
    }
  }
}
</style>
